// imports
import { Alert, CircularProgress, Grid, Typography } from '@mui/material';
import { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import { PlainLayout } from 'components/common/PlainLayout';
import { PlanCard } from './PlanCard';

// interfaces, constants, helper
import {
  CHOOSE_YOUR_PLAN_TEXT,
  ERROR_FETCHING_PLANS_TEXT,
  NO_CREDIT_CARD_REQUIRED_TEXT,
  NO_SUBSCRIPTION_PLAN_TEXT,
  PLAN_TRIAL_TEXT,
} from 'constants/constant';
import { DASHBOARD_ROUTE } from 'constants/index';
import { UserSubscriptionsContext } from 'contexts/UserSubscriptions';
import { useFindPriceAndProductsQuery } from 'generated/graphql';
import { AuthLayoutContainer } from 'theme/styleComponent';

export const Plans: FC = () => {
  const navigate = useNavigate();
  const { data, loading, error } = useFindPriceAndProductsQuery();
  const { findPriceAndProducts } = data || {};
  const { prices } = findPriceAndProducts || {};
  const { userSubscription } = useContext(UserSubscriptionsContext);
  const { id } = userSubscription || {};

  useEffect(() => {
    id && navigate(DASHBOARD_ROUTE);
  }, [id, navigate]);

  if (loading) {
    return (
      <AuthLayoutContainer>
        <CircularProgress size={40} thickness={4} />
      </AuthLayoutContainer>
    );
  }

  if (error) {
    return (
      <AuthLayoutContainer>
        <Alert severity="error" variant="filled">
          {ERROR_FETCHING_PLANS_TEXT}
        </Alert>
      </AuthLayoutContainer>
    );
  }

  if (!prices?.length) {
    return (
      <AuthLayoutContainer>
        <Alert severity="info" variant="outlined">
          {NO_SUBSCRIPTION_PLAN_TEXT}
        </Alert>
      </AuthLayoutContainer>
    );
  }

  return (
    <PlainLayout
      title={
        <>
          {CHOOSE_YOUR_PLAN_TEXT} <br /> {PLAN_TRIAL_TEXT}
        </>
      }
      maxWidth="750px">
      <Grid container spacing={4} justifyContent="center">
        {prices.map((item) => {
          const { id, product, interval, amount } = item || {};
          return (
            <Grid item xs={12} md={6} key={id}>
              <PlanCard priceId={id} product={product} interval={interval} amount={amount} />
            </Grid>
          );
        })}
      </Grid>
      <Typography variant="h5" textAlign="center" mt={4}>
        {NO_CREDIT_CARD_REQUIRED_TEXT}
      </Typography>
    </PlainLayout>
  );
};
